import PlayMode from "../model/PlayMode";

export default class GlobalPlatformParameters {

    constructor(language, playMode, environment, payload) {
        this._language = language;
        this._playMode = playMode;
        this._environment = environment;
        this._payload = payload;
    }

    /**
     * @returns {Object} Generic object containing game state (savegame) or null
     */
    get state() {
        return this._state;
    }

    /**
     * @returns {String} Language id
     */
    get language() {
        return this._language;
    }

    /**
     * @returns {PlayMode} Playmode: assessment or demo
     */
    get playMode() {
        return this._playMode;
    }

    get environment() {
        return this._environment;
    }

    get payload() {
        return this._payload;
    }

    /**
     * @param {Object} obj 
     * @returns {GlobalPlatformParameters} 
     */
    static fromObject(obj) {
        return new GlobalPlatformParameters(
            obj.language,
            GlobalPlatformParameters.parsePlayMode(obj.play_mode),
            obj.environment,
            obj,
        );
    }

    static parsePlayMode(str) {
        switch (str) {
            case "demo":
                return PlayMode.DEMO;
            case "assessment":
            case null:
            case undefined:
                return PlayMode.ASSESSMENT;
            default:
                throw new Error("Invalid value for play_mode: " + str);
        }
    }
}

